import PropTypes from 'prop-types';
import { Component, createRef } from 'react';

interface Props {
    onClickOutside: (event: MouseEvent) => void;
    enabled: boolean;
    className?: string;
}

export default class ClickOutside extends Component<React.PropsWithChildren<Props>> {
    static propTypes = {
        onClickOutside: PropTypes.func.isRequired,
        children: PropTypes.node.isRequired,
        enabled: PropTypes.bool.isRequired,
        className: PropTypes.string,
    };

    node = createRef<HTMLSpanElement>();

    handleDocumentClick = (event: MouseEvent) => {
        if (this.node.current === null) {
            return;
        }
        if (!this.node.current.contains(event.target as Node)) {
            this.props.onClickOutside(event);
        }
    };

    controlListener(attach: boolean) {
        if (attach) {
            document.addEventListener('click', this.handleDocumentClick);
        } else {
            document.removeEventListener('click', this.handleDocumentClick);
        }
    }

    componentDidMount() {
        this.controlListener(this.props.enabled);
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.enabled !== this.props.enabled) {
            this.controlListener(this.props.enabled);
        }
    }

    componentWillUnmount() {
        this.controlListener(false);
    }

    render() {
        return (
            <span ref={this.node} className={this.props.className}>
                {this.props.children}
            </span>
        );
    }
}
